import {createActions} from './api'
import {queryTypes} from '../../constants/cart'

const cart = createActions('cart')

export const fetchCart = (cached = false, type = queryTypes.FULL) =>
  cart.get({cached, query: {type}})

export const createCartLineItem = (body) =>
  cart.create({path: '/items', options: {body}})

export const updateCartLineItem = (id, body) =>
  cart.update({
    path: `/items/${id}`,
    options: {body},
    merge: (c) => c.CartLineItems.some((cli) => cli.CartLineItemID === id)
  })

export const deleteCartLineItem = (id) =>
  cart.delete({
    path: '/items',
    query: {id},
    merge: (c) => c.CartLineItems.some((cli) => cli.CartLineItemID === id)
  })
